<div *ngIf="data.type =='edit'" class="dialog-overlay">
    <div class="company-dialog">
        <div class="dialog-header">
            <h2 class="dialog-title">Edit Company Information</h2>
            <button type="button" class="close-btn" (click)="cancel()">
                <img src="/assets/images/close.svg" alt="close" width="16" height="16">
            </button>
        </div>
        <div class="dialog-content">
            <form [formGroup]="form" class="personalInfo">
                <div class="row">
                    <div class="col">
                        <div class="row">       
                                <label>Company ID</label>
                            
                            <div class="col-sm-12">
                                <input type="text" formControlName="company_id" class="infofield" required
                                    placeholder="Company ID" disabled>
                                <div class="erroMessage"
                                    *ngIf="form.get('company_id')?.errors?.['required']">
                                    Company ID is required.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="row">
                            
                                <label>Company Name</label>
                            <div class="col-sm-12">
                                <input type="text" formControlName="name" class="infofield" required placeholder="Company Name" disabled>
                                <div class="erroMessage"
                                    *ngIf="form.get('name')?.errors?.['required']">
                                    Company name is required.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="row">
                           
                                <label>Code</label>
                         
                            <div class="col-sm-12">
                                <input type="text" formControlName="code" class="infofield" required placeholder="Company Code">
                                <div class="erroMessage"
                                    *ngIf="form.get('code')?.errors?.['required']">
                                    Code is required.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="row">
                           
                                <label>Address</label>
                         
                            <div class="col-sm-12">
                                <input type="text" formControlName="address" class="infofield" placeholder="Company Address" >
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="row">
                           
                                <label>Company Type <span class="man-field"></span></label>
                          
                            <div class="col-sm-12">
                                <select formControlName="company_type" class="infofield" required>
                                    <option value="">Select Type</option>
                                    <option *ngFor="let obj of companyType " [value]="obj.key">{{obj.value}}</option>
                                </select>
                                <div class="erroMessage"
                                    *ngIf="form.get('company_type')?.errors?.['required']">
                                    Company Type is required.</div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <!-- Empty column for layout consistency -->
                    </div>
                </div>
            </form>
        </div>
        <div class="dialog-actions">
            <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
            <button 
                type="submit" 
                class="btn btn-primary" 
                [disabled]="!form.valid"
                (click)="onSubmit()">Update Company</button>
        </div>
    </div>
</div>



<div *ngIf="data.type =='create'" class="dialog-overlay">
    <div class="company-dialog">
        <div class="dialog-header">
            <h2 class="dialog-title">Add Company Information</h2>
            <button type="button" class="close-btn" (click)="cancel()">
                <img src="/assets/images/close.svg" alt="close" width="16" height="16">
            </button>
        </div>
        <div class="dialog-content">
            <form [formGroup]="form" class="personalInfo">
                <div class="row">
                    <div class="col">
                        <div class="row">
                                <label>Company Name</label>
                            
                            <div class="col-sm-12">
                                <input type="text" formControlName="name" class="infofield" required placeholder="Company Name">
                                <div class="erroMessage"
                                    *ngIf="form.get('name')?.errors?.['required']">
                                    Company name is required.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="row">
                            
                                <label>Code</label>
                            
                            <div class="col-sm-12">
                                <input type="text" formControlName="code" class="infofield" required placeholder="Company Code">
                                <div class="erroMessage"
                                    *ngIf="form.get('code')?.errors?.['required']">
                                    Code is required.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="row">
                          
                                <label>Address</label>
                            
                            <div class="col-sm-12">
                                <input type="text" formControlName="address" class="infofield" placeholder="Company Address">
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="row">
                          
                                <label>Company Type</label>
                            
                            <div class="col-sm-12">
                                <select formControlName="company_type" class="infofield" required>
                                    <option value="">Select Type</option>
                                    <option *ngFor="let obj of companyType " [value]="obj.key">{{obj.value}}</option>
                                </select>
                                <div class="erroMessage"
                                    *ngIf="form.get('company_type')?.errors?.['required']">
                                    Company Type is required.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="dialog-actions">
            <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
            <button type="submit" class="btn btn-primary" 
                [disabled]="!form.valid" 
                [style.cursor]="!form.valid ? 'not-allowed' : 'pointer'"
                (click)="onSubmit()">Submit</button>
        </div>
    </div>
</div>